<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Sign In As</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickDiscardChanges"
                >
                    Cancel
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="margin-top: 15px"
        >

        <v-row>
            <v-col>
                <v-text-field
                    label="Search"
                    prepend-icon="mdi-magnify"
                    v-model="full_text"
                    v-on:input="update"
                    autofocus
                    @keydown.enter="onClickFirstRow"
                    autocomplete="off"
                />
            </v-col>
            <v-col
                style="flex-grow: 0"
            >
                <m-restricted-button
                    style="margin-top: 15px"
                    v-on:click="$rc.$state.isAuthActorSystemAdmin() ? onClickEnrolling() : null"
                    v-if="$rc.$state.isAuthActorSystemAdmin()"
                >
                    Enrolling
                </m-restricted-button>
            </v-col>
        </v-row>



            <v-data-table
                :headers="headers"
                :items="results"
                :items-per-page="100"
                class="elevation-1"
                hide-default-footer
                v-on:click:row="onClickRow"
            >
                <!-- Admin-only column headers -->
                <template v-if="$rc.$state.isAuthActorSystemAdmin()" v-slot:header.tags>
                    <m-restricted-table-header-cell text="Tags" />
                </template>

                <template v-if="$rc.$state.isAuthActorSystemAdmin()" v-slot:header.is_system_admin>
                    <m-restricted-table-header-cell text="System Admin" />
                </template>

                <template v-if="$rc.$state.isAuthActorSystemAdmin()" v-slot:header.is_organization_admin>
                    <m-restricted-table-header-cell text="Organization Admin" />
                </template>

                <template v-if="$rc.$state.isAuthActorSystemAdmin()" v-slot:header.is_archived>
                    <m-restricted-table-header-cell text="Archived" />
                </template>

                <template v-if="$rc.$state.isAuthActorSystemAdmin()" v-slot:header.has_set_password>
                    <m-restricted-table-header-cell text="Has Password" />
                </template>

                <template v-if="$rc.$state.isAuthActorSystemAdmin()" v-slot:header.integrations>
                    <m-restricted-table-header-cell text="Integrations" />
                </template>
                <template v-slot:item.tags="{ item }">
                    <m-rc-tag-display
                        :value="item.rc_tags"
                    />
                </template>

                <template v-slot:item.is_system_admin="{ item }">
                    <div class="d-flex justify-center">
                        <v-simple-checkbox v-model="item.is_system_admin" disabled></v-simple-checkbox>
                    </div>
                </template>

                <template v-slot:item.is_organization_admin="{ item }">
                    <div class="d-flex justify-center">
                        <v-simple-checkbox v-model="item.is_organization_admin" disabled></v-simple-checkbox>
                    </div>
                </template>

                <template v-slot:item.is_archived="{ item }">
                    <div class="d-flex justify-center">
                        <v-simple-checkbox v-model="item.is_archived" disabled></v-simple-checkbox>
                    </div>
                </template>

                <template v-slot:item.is_organization_archived="{ item }">
                    <div class="d-flex justify-center">
                        <v-simple-checkbox v-model="item.is_organization_archived" disabled></v-simple-checkbox>
                    </div>
                </template>

                <template v-slot:item.has_set_password="{ item }">
                    <div class="d-flex justify-center">
                        <v-simple-checkbox v-model="item.has_set_password" disabled></v-simple-checkbox>
                    </div>
                </template>

                <template v-slot:item.integrations="{ item }">
                    {{$rc.pretty(item.active_integrations, 'comma_list')}}
                </template>

                <template v-slot:item.username="{ item }">
                    <v-icon
                        size="16"
                        style="position: relative; top: -2px"
                        v-on:click.stop="onClickCopyUsername(item)"
                    >
                        mdi-content-copy
                   </v-icon>

                   {{item.username}}
                </template>

                <template v-slot:item.employee_label="{ item }">
                    <v-icon
                        size="16"
                        style="position: relative; top: -2px"
                        v-on:click.stop="onClickCopyName(item)"
                    >
                        mdi-content-copy
                   </v-icon>

                   {{item.employee_label}}
                </template>


            </v-data-table>

        </v-card-text>

    </v-card>

</v-dialog>
</template>

<script>

const _ = require('lodash');

export default {

    data() {
        return {
            dialog: false,
            full_text: null,
            results: [],
        }
    },

    methods: {

        update: _.debounce(function(){
            this.doUpdate();
        }, 751),

        doUpdate()
        {

            this.$rc.rest(
                'LIST: /api/v1/employees/list-sign-in-as',

                {
                    'full_text' : this.full_text,
                },

                (data) => {
                    this.results = data.results;
                },

                () => {
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },


        showDialog()
        {
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
            this.doUpdate();
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }

            this.dialog = false;
            next(false);
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        onClickRow(item)
        {

            if ( item.is_system_admin && !this.$rc.$state.hasRedChirpStaffRoleAdministrator() && item.employee_id != this.$rc.$state.getAuthEmployeeId() )
            {
                this.$rc.alert('You can not sign in as another RedChirp staff member', 'Only RedChirp staff members with the Administrator role can sign in as other RedChirp staff members');
                return;
            }

            this.signInAs(item);
        },

        onClickFirstRow()
        {
            if ( this.results.length == 0 )
                return;

            this.signInAs(this.results[0]);
        },

        signInAs(item)
        {
            let employee_id = item.employee_id;
            this.closeDialog();

            // Delay to make sure dialog has time to close...
            window.setTimeout(
                () =>{
                    this.$rc.newSignInAs(
                        {
                            'organization_id': item.organization_id,
                            'employee_id': item.employee_id,
                        }
                    );
                },
                250
            );
        },


        onClickEnrolling()
        {
            this.closeDialog();
            this.$router.push({
                'name': 'admin-search-organizations',
                'params' : {
                },
                'query': {
                    'search_state': 'pre-launch',
                },
            });
        },

        onClickCopyUsername(item)
        {
            this.$rc.copy(item.username);
        },

        onClickCopyName(item)
        {
            this.$rc.copy(item.employee_label);
        },


    },

    computed: {
        headers() {
            if ( this.$rc.$state.isAuthActorSystemAdmin() )
            {
                return [
                    { text: 'Tags', value: 'tags', align: 'start' },
                    { text: 'Organization', value: 'organization_label', align: 'start' },
                    { text: 'Username', value: 'username', align: 'start' },
                    { text: 'Name', value: 'employee_label', align: 'start' },
                    { text: 'System Admin', value: 'is_system_admin', align: 'center' },
                    { text: 'Organization Admin', value: 'is_organization_admin', align: 'center' },
                    { text: 'Archived', value: 'is_archived', align: 'center' },
                    { text: 'Has Password', value: 'has_set_password', align: 'center' },
                    { text: 'Integrations', value: 'integrations', align: 'start' },

                ];
            }
            else
            {
                return [
                    { text: 'Organization', value: 'organization_label', align: 'start' },
                    { text: 'Username', value: 'username', align: 'start' },
                    { text: 'Name', value: 'employee_label', align: 'start' },
                ];
            }
        }
    },
}
</script>
